// initial state
const state = {
  update: false
}

// getters
const getters = {}

// actions
const actions = {
  updateFun(context) {
    //这里的context和我们使用的$store拥有相同的对象和方法
    context.commit('updateFun');
    //你还可以在这里触发其他的mutations方法
  }
}

// mutations
const mutations = {
  updateFun(state) {
    //这里的state对应着上面这个state
    state.update = !state.update;
    //你还可以在这里执行其他的操作改变state
  }

}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/updateInfo.js